"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  errorDuringTenantsFetch: {
    "id": "tenants.errorDuringTenantsFetch",
    "defaultMessage": "An error occurred while fetching tenants."
  },
  tenantWithIdDoesNotExist: {
    "id": "tenants.tenantWithIdDoesNotExist",
    "defaultMessage": "Tenant with ID \"{tenantId}\" was not found."
  },
  tenantName: {
    "id": "tenants.tenantName",
    "defaultMessage": "Name"
  },
  tenantNamePlaceholder: {
    "id": "tenants.tenantNamePlaceholder",
    "defaultMessage": "Choose a name"
  },
  tenantDomain: {
    "id": "tenants.tenantDomain",
    "defaultMessage": "Domain"
  },
  tenantDomainPlaceholder: {
    "id": "tenants.tenantDomainPlaceholder",
    "defaultMessage": "Enter a domain"
  },
  parentTenant: {
    "id": "tenants.parentTenant",
    "defaultMessage": "Parent Tenant"
  },
  updateTenant: {
    "id": "tenants.updateTenant",
    "defaultMessage": "Update tenant"
  },
  deleteTenant: {
    "id": "tenants.deleteTenant",
    "defaultMessage": "Delete tenant"
  },
  deleteDesc: {
    "id": "tenants.deleteDesc",
    "defaultMessage": "Are you sure you want to delete this tenant?"
  },
  deleteDesc2: {
    "id": "tenants.deleteDesc2",
    "defaultMessage": "This action cannot be undone."
  },
  addNewTenant: {
    "id": "tenants.addNewTenant",
    "defaultMessage": "Add new tenant"
  },
  selectATenantToUpdateIt: {
    "id": "tenants.selectATenantToUpdateIt",
    "defaultMessage": "Select a tenant to see or edit its details."
  },
  tenantSuccessfullyCreated: {
    "id": "tenants.tenantSuccessfullyCreated",
    "defaultMessage": "Tenant was successfully created."
  },
  errorDuringTenantCreation: {
    "id": "tenants.errorDuringTenantCreation",
    "defaultMessage": "There was an error while creating a tenant."
  },
  tenantAlreadyExists: {
    "id": "tenants.tenantAlreadyExists",
    "defaultMessage": "A tenant with this name already exists."
  },
  tenantSuccessfullyUpdated: {
    "id": "tenants.tenantSuccessfullyUpdated",
    "defaultMessage": "Tenant was successfully updated."
  },
  tenantSuccessfullyDeleted: {
    "id": "tenants.tenantSuccessfullyDeleted",
    "defaultMessage": "Tenant was successfully deleted."
  },
  errorDuringTenantUpdate: {
    "id": "tenants.errorDuringTenantUpdate",
    "defaultMessage": "There was an error while updating a tenant."
  },
  errorDuringTenantDeletion: {
    "id": "tenants.errorDuringTenantDeletion",
    "defaultMessage": "There was an error while deleting a tenant."
  },
  manageAssignedTenants: {
    "id": "tenants.manageAssignedTenants",
    "defaultMessage": "Manage assigned tenants"
  }
});
exports.messages = messages;
//# sourceMappingURL=tenants-i18n.js.map